module.exports = __webpack_public_path__ + "media/images/games/clash-royale/card-unknown-c7fca15d62263c51bf198eeef61d0065.png";